<div class="h-full w-full flex flex-grow">
  @if (statData !== null) {
  <div class="bg-[#252A30] h-full w-full flex justify-center items-center">
    @if (!isDeviceOffline) {
    @if (!noxAlert) {
    @if (
    (statData?.plantType === plantType.SOLAR &&
    statData?.inverterType === inverterType.GTI) ||
    statData?.inverterType === inverterType.ThinkPower
    ) {
    <div class="sm:w-[70%] md:w-[100%] lg:w-[90%] sm:py-6 md:py-6 flex flex-col items-stretch">
      <div class="flex w-full items-center">
        <div class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit border-[2px] border-solid"
          [ngClass]="
                    this.statData?.stats?.grid_state?.toString() == '1'
                      ? 'border-light-red-variant-1'
                      : 'border-light-green-variant-1'
                  ">
          <img src="../../../../../assets/svg/solar-icon.svg" class="energy-icon-size sm:m-2.5 lg:m-3" alt="preview" />
        </div>
        <div class="flex-grow lines">
          <div class="w-full bg-white rounded-sm overflow-hidden">
            <div class="h-1 w-full flex-grow">
              <div class="progress" [ngClass]="{
                          'animate-left-to-right': animationFlow.solarToCenter
                        }"></div>
            </div>
          </div>
        </div>
        <div class="rounded-full flex justify-center items-center sm:w-7 sm:h-7 lg:w-10 lg:h-10 m-auto">
          <div class="w-fit h-fit">
            <img src="../../../../../assets/svg/preview-center.svg" class="sm:w-7 sm:h-7 lg:w-10 lg:h-10"
              alt="preview" />
          </div>
        </div>
        <div class="flex-grow lines">
          <div class="w-full bg-white rounded-sm overflow-hidden">
            <div class="h-1 w-full">
              <div class="progress" [ngClass]="{
                          'animate-left-to-right': animationFlow.centerToGrid,
                          'animate-right-to-left': animationFlow.gridToCenter
                        }"></div>
            </div>
          </div>
        </div>
        <div class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit border-[2px] border-solid"
          [ngClass]="
                    this.statData?.stats?.grid_state?.toString() == '1'
                      ? 'border-light-red-variant-1'
                      : 'border-light-green-variant-1'
                  ">
          <img src="../../../../../assets/svg/grid-icon.svg" class="energy-icon-size sm:m-2.5 lg:m-3" alt="preview" />
        </div>
      </div>
      <div class="flex justify-between w-full mt-3">
        <div class="flex flex-col h-fit w-fit text-center -ml-4">
          <span class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{ "solar_power" |
            translate }}</span>
          <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">{{
            statData?.stats?.solar_power ?? 0 }} kW</span>
        </div>
        @if(+statData!.stats.phase_a_voltage != 0 &&
        +statData!.stats.phase_b_voltage == 0 &&
        +statData!.stats.phase_c_voltage == 0){
        <div class="flex flex-col h-fit w-fit text-center -mr-4">
          <span class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{ "grid_voltage" |
            translate }}</span>
          <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
            {{ statData!.stats.phase_a_voltage + " V" || "NA" }}
          </span>
        </div>}
        @if(+statData!.stats.phase_a_voltage != 0 &&
        +statData!.stats.phase_b_voltage != 0 &&
        +statData!.stats.phase_c_voltage != 0
        ){
        <div class="flex flex-col -mr-4" [ngClass]="
                    +statData!.stats.phase_a_voltage != 0 &&
                    +statData!.stats.phase_b_voltage != 0 &&
                    +statData!.stats.phase_c_voltage != 0
                      ? 'justify-between'
                      : 'justify-center'
                  ">
          @if(+statData!.stats.phase_a_voltage != 0){
          <div class="col-span-1">
            <div>
              <span class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">
                {{ "a_phase" | translate }}
              </span>
            </div>
            <div>
              <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
                {{ statData!.stats.phase_a_voltage + " V" || "NA" }}
              </span>
            </div>
          </div>}
          @if(+statData!.stats.phase_b_voltage != 0){
          <div class="col-span-1 mt-1.5">
            <div>
              <span class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">
                {{ "b_phase" | translate }}
              </span>
            </div>
            <div>
              <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
                {{ statData!.stats!.phase_b_voltage + " V" || "NA" }}
              </span>
            </div>
          </div>}
          @if(+statData!.stats.phase_c_voltage != 0){
          <div class="col-span-1 mt-1.5">
            <div>
              <span class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">
                {{ "c_phase" | translate }}
              </span>
            </div>
            <div>
              <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
                {{ statData!.stats.phase_c_voltage + " V" || "NA" }}
              </span>
            </div>
          </div>}
        </div>}
      </div>

      <div class="flex flex-col justify-center items-center">
        @if (statData?.stats?.grid_state == "1") {
        <span class="text-white label-xs text-center m-auto mb-5">
          Solar generation paused due to power cut, will resume when
          power's back.
        </span>
        }
        @if (stringInfo) {
        <div
          class="flex justify-center items-center rounded-xl bg-dark-accent-secondary px-4 py-3 text-white cursor-default gap-x-1"
          (appClickableDirective)="sideSheet.toggle()">
          <span class="text-xs p-0">{{
            "string_info" | translate
            }}</span>
          <img src="../../../../../assets/svg/arrow_forward.svg" alt="arrow" />
        </div>

        <div class="text-white cursor-default">
          <app-string-info [statsData]="statData" [plantName]="plantName"></app-string-info>
        </div>
        }

      </div>
    </div>
    }
    <!-- Preview SolarVerter -->
    @if (
    this.statData?.plantType === plantType.SOLAR &&
    statData?.inverterType !== inverterType.GTI &&
    statData?.inverterType !== inverterType.ThinkPower && statData?.inverterType!==inverterType.THINKPOWERHESM
    ) {

    <div class="flex flex-col items-center w-full">
      <div class="w-full h-full xl:hidden sm:hidden lg:flex">
        <div class="flex flex-col flex-grow">
          <div class="flex justify-center items-center flex-col w-full">
            <div class="justify-center items-center px-2 w-full flex text-white">
              <div class="flex flex-col flex-wrap items-center">
                <span class="text-[12px] font-normal text-[#AEAEAE] p-0 m-0 leading-none">{{ "solar_power" | translate
                  }}</span>
                <span class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB]">{{ statData?.stats?.solar_power
                  ??
                  0
                  }} {{statData?.inverterType===inverterType.ARCTIC_HYBRID?'W':'kW'}}</span>
              </div>
            </div>
          </div>
          <div class="flex flex-row flex-grow my-1 items-center justify-center">
            <div class="grid grid-cols-5 row-span-5 justify-center items-center px-3 grid-auto">
              <div class="col-span-5 rounded-full flex justify-center items-center m-auto border-[2px] border-solid"
                [ngClass]="
                        this.statData?.stats?.solar_state?.toString() == '0'
                          ? 'border-light-red-variant-1'
                          : 'border-light-green-variant-1'
                      ">
                <img src="../../../../../assets/svg/solar-icon.svg"
                  class="sm:h-[33px] sm:w-[33px] lg:h-[31px] lg:w-[31px]  xxl:h-[40px] xxl:w-[40px] sm:m-2.5 lg:m-3"
                  alt="preview" />
              </div>
              <div class="col-span-2"></div>
              <div class="col-span-1 row-span-1 flex justify-center m-0 h-full line">
                <div class="h-full bg-white rounded-sm overflow-hidden">
                  <div class="h-full w-1">
                    <div class="progress-vertical" [ngClass]="{
                              'animate-top-to-bottom':
                                animationFlow.solarToCenter
                            }"></div>
                  </div>
                </div>
              </div>
              <div class="col-span-2 flex justify-end items-end h-full  mb-2">
                @if (statData?.inverterType === inverterType.ENERTECH_SOLAR ||(
                statData?.inverterType === inverterType.ARCTIC_HYBRID &&
                statData?.stats?.phaseType===3
                )){
                <div class="flex h-full justify-end items-end gap-2 -mr-2.5">
                  <div class="rounded-full text-sm h-5 w-5 text-center flex items-center justify-center     " [ngClass]="
                    statData?.phase?.phaseR
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">R</div>
                  <div class="rounded-full  text-sm h-5 w-5 text-center flex items-center justify-center  " [ngClass]="
                    statData?.phase?.phaseY
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">Y</div>
                  <div class="rounded-full text-sm h-5 w-5 text-center flex items-center justify-center  " [ngClass]="
                    statData?.phase?.phaseB
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">B</div>
                </div>

                }
              </div>
              <div class="col-span-1 rounded-full flex justify-center items-center m-auto border-[2px] border-solid"
                [ngClass]="getGridBorderClass()">
                <img src="../../../../../assets/svg/grid-icon.svg" class="energy-icon-size  sm:m-2.5 lg:m-3"
                  alt="preview" />
              </div>
              <div class="w-full">
                <div class="w-full bg-white rounded-sm overflow-hidden">
                  <div class="h-1 w-full">
                    <div class="progress" [ngClass]="{
                              'animate-left-to-right':
                                animationFlow.gridToCenter,
                              'animate-right-to-left':
                                animationFlow.centerToGrid
                            }"></div>
                  </div>
                </div>
              </div>
              <div
                class="col-span-1 rounded-full flex justify-center items-center sm:w-7 sm:h-7 xl:w-10 xl:h-10 m-auto">
                <img src="../../../../../assets/svg/preview-center.svg" class="sm:w-7 sm:h-7 xl:w-10 xl:h-10"
                  alt="preview" />
              </div>
              <div class="w-full">
                <div class="w-full bg-white rounded-sm overflow-hidden">
                  <div class="h-1 w-full">
                    <div class="progress" [ngClass]="{
                              'animate-left-to-right':
                                animationFlow.centerToHome
                            }"></div>
                  </div>
                </div>
              </div>
              <div class="col-span-1 rounded-full flex justify-center items-center m-auto border-[2px] border-solid"
                [ngClass]="
                        animationFlow.centerToHome
                          ? 'border-light-green-variant-1'
                          : 'border-light-gray-variant-1'
                      ">
                @if(statData?.inverterType === inverterType.ENERTECH_SOLAR
                ||statData?.inverterType===inverterType.ARCTIC_HYBRID ){
                <img src="../../../../assets/svg/load_state.svg" class="energy-icon-size sm:m-2.5 lg:m-3"
                  alt="preview" />
                } @else{
                <img src="../../../../../assets/svg/home-icon.svg" class="energy-icon-size  sm:m-2.5 lg:m-3"
                  alt="preview" />}
              </div>

              <div class="col-span-2 flex flex-col justify-start items-start mt-2 ">
                <div class="flex flex-col flex-wrap items-center">
                  @if (statData?.inverterType === inverterType.ENERTECH_SOLAR ||
                  statData?.inverterType===inverterType.ARCTIC_HYBRID
                  ) {
                  @if(statData?.inverterType===inverterType.ENERTECH_SOLAR){

                  <span class="text-[12px] p-0 mt-1 leading-none font-normal text-[#AEAEAE]">{{
                    "total_grid"
                    | translate }}</span>} @else {
                  <span class="text-[12px] p-0 mt-1 leading-none font-normal text-[#AEAEAE]">{{
                    "grid_power"
                    | translate }}</span>
                  }
                  <span class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB]">
                    {{ statData?.stats?.totalGrid ?? 0 }}
                    {{statData?.inverterType===inverterType.ARCTIC_HYBRID?'W':'kW'}}
                  </span>
                  }@else{
                  <span class="text-[12px] p-0 mt-1 leading-none font-normal text-[#AEAEAE]">{{ "grid_voltage" |
                    translate
                    }}</span>
                  <span class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB]">{{
                    this.statData?.stats?.input_voltage ?? "0"
                    }}
                    V</span>}
                </div>
              </div>
              <div class="col-span-1 flex justify-center m-0 h-full">
                <div class="h-full bg-white rounded-sm overflow-hidden">
                  <div class="h-full w-1">
                    <div class="progress-vertical" [ngClass]="{
                              'animate-top-to-bottom':
                                animationFlow.centerToBattery,
                              'animate-bottom-to-top':
                                animationFlow.batteryToCenter
                            }"></div>
                  </div>
                </div>
              </div>
              <div class="col-span-2 flex justify-end text-end  items-center mt-2   ml-5 -mr-2  ">
                <div class="flex flex-col flex-wrap items-center">

                  @if (statData?.inverterType === inverterType.ENERTECH_SOLAR ){
                  <span class="text-[12px] p-0 mt-1 leading-none font-normal tex text-[#AEAEAE]">{{
                    "total_load" | translate }}</span>
                  }
                  @else if(statData?.inverterType===inverterType.ARCTIC_HYBRID){
                  <span class="text-[12px] p-0 mt-1 leading-none font-normal tex text-[#AEAEAE]">{{
                    "load_power" | translate }}</span>
                  } @else{
                  <span class="text-[12px] p-0 mt-1 leading-none font-normal tex text-[#AEAEAE]">{{
                    "home" | translate }}</span>}
                  <span class="text-[15px] pt-1 leading-none font-normal text-nowrap text-[#EBEAEB]">
                    {{ this.statData?.stats?.consumptionValue ?? "0"
                    }}{{statData?.inverterType===inverterType.ARCTIC_HYBRID?' VA':' kW'}}</span>
                </div>
              </div>
              @if(statData?.inverterType === inverterType.ENERTECH_SOLAR ||
              statData?.inverterType===inverterType.ARCTIC_HYBRID){
              <div class="col-span-5 rounded-full flex justify-center items-center m-auto border-[2px] border-solid"
                [ngClass]="statData?.stats?.batteryState=='Red'?'border-light-red-variant-1':'border-light-green-variant-1'"
                [ngClass]="statData?.stats?.batteryState=='Yellow'?'border-yellow-300':'border-light-green-variant-1'"
                [ngClass]="statData?.stats?.batteryState=='Green'?'border-light-green-variant-1':'border-white'">
                <div class="relative w-fit  sm:m-2.5 lg:m-3">
                  <div class="sm:w-[29px] sm:h-[29px] lg:w-[27px] lg:h-[27px]  xxl:h-[42px] xxl:w-[42px]">
                    <div
                      class="w-full h-full absolute top-0 left-0 flex justify-end items-end border-[0.5px] border-solid border-white rounded-b-sm">
                      <div class="w-full bg-[#0051ba] rounded-b-sm" [ngStyle]="{
                                height: calculateBatteryProgress(
                                  statData?.stats
                                )
                              }"></div>
                    </div>
                    <div class="battery-top-left"></div>
                    <div class="battery-top-right"></div>
                  </div>
                </div>
              </div>
              }@else{
              <div class="col-span-5 rounded-full flex justify-center items-center m-auto border-[2px] border-solid"
                [ngClass]="
                        animationFlow.centerToBattery ||
                        animationFlow.batteryToCenter
                          ? 'border-light-green-variant-1'
                          : 'border-light-gray-variant-1'
                      ">
                <div class="relative w-fit  sm:m-2.5 lg:m-3">
                  <div class="sm:w-[29px] sm:h-[29px] lg:w-[27px] lg:h-[27px]  xxl:h-[42px] xxl:w-[42px]">
                    <div
                      class="w-full h-full absolute top-0 left-0 flex justify-end items-end border-[0.5px] border-solid border-white rounded-b-sm">
                      <div class="w-full bg-[#0051ba] rounded-b-sm" [ngStyle]="{
                                height: calculateBatteryProgress(
                                  statData?.stats
                                )
                              }"></div>
                    </div>
                    <div class="battery-top-left"></div>
                    <div class="battery-top-right"></div>
                  </div>
                </div>
              </div>}
            </div>
          </div>
          @if(statData?.inverterType === inverterType.ENERTECH_SOLAR ){
          <div class="flex justify-center items-center w-full flex-col text-white">
            <span
              class="text-[12px] p-0 mt-1 leading-none font-normal text-[#AEAEAE]">{{"battery_charging"|translate}}</span>
            <div class="text-[15px] p-0 mt-1 leading-none font-normal text-[#EBEAEB]">
              {{statData?.stats?.battery_charge_percentage}}%</div>
          </div>
          } @else if(statData?.inverterType === inverterType.ARCTIC_HYBRID){
          <div class="flex justify-center items-center w-full flex-col text-white">
            <span
              class="text-[12px] p-0 mt-1 leading-none font-normal text-[#AEAEAE]">{{"battery_power"|translate}}</span>
            <div class="text-[15px] p-0 mt-1 leading-none font-normal text-[#EBEAEB]">
              {{statData?.stats?.batteryPower}} W | {{statData?.stats?.battery_charge_percentage}}% </div>
          </div>
          }
          @else{
          <div class="flex justify-center items-center w-full">
            <div class="justify-center items-center px-2 flex w-full">
              <div class="flex flex-col flex-wrap items-center">
                <span class="text-[12px] p-0 mt-1 leading-none font-normal text-[#AEAEAE]">{{
                  this.statData?.stats?.batteryState?.toString() != "0"
                  ? "Charging"
                  : getState(this.statData?.stats)
                  }}</span>
                @if (
                this.statData?.stats?.batteryState?.toString() != "0"
                ) {
                <span class="text-[15px] p-0 mt-1 leading-none font-normal text-[#EBEAEB]">(
                  {{
                  this.statData?.stats?.time_remaining_for_charging
                  | noxDate
                  }}
                  to charge)</span>
                } @else {
                @if (
                getNumber(statData?.stats?.discharging_current) > 1 ||
                getNumber(statData?.stats?.discharge) > 1
                ) {
                <span class="text-[15px] p-0 mt-1 leading-none font-normal text-[#EBEAEB]">(
                  {{
                  this.statData?.stats?.available_backup
                  ? (this.statData?.stats?.available_backup
                  | noxDate)
                  : (this.statData?.stats
                  ?.time_remaining_for_discharging | noxDate)
                  }}
                  remaining)</span>
                } @else {
                <span class="text-[15px] p-0 mt-1 leading-none font-normal text-[#EBEAEB]">(
                  {{
                  this.statData?.stats?.time_remaining_for_charging
                  | noxDate
                  }}
                  to charge)</span>
                }
                }
              </div>
            </div>
          </div>}
        </div>
        @if (statData?.inverterType!==inverterType.ARCTIC_HYBRID) {
        <div class="flex justify-center items-center ">
          <span class="vertical-text text-[#EFEDEF] text-sm m-0">Load Priority: {{ statData?.solarSetting }}
          </span>
        </div>}
      </div>

      <div class="w-full h-full xl:flex sm:flex lg:hidden    ">
        <div class="flex flex-col flex-grow">
          <div class="justify-center items-center px-2 text-white mr-5 flex w-full">
            <div class="flex flex-col flex-wrap items-center">
              <span class="sm:text-base p-0 md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{
                "solar_power"
                |
                translate }}</span>
              <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">{{
                statData?.stats?.solar_power ?? 0 }}
                {{statData?.inverterType===inverterType.ARCTIC_HYBRID?'W':'kW'}}</span>
            </div>
          </div>

          <div class="flex flex-row flex-grow my-1 justify-center">
            <div class="grid grid-cols-5 row-span-5 justify-center items-center px-3 grid-auto">
              <div
                class="m-auto col-span-5 rounded-full flex justify-center items-center h-fit w-fit border-[2px] border-solid"
                [ngClass]="
                        this.statData?.stats?.solar_state?.toString() == '0'
                          ? 'border-light-red-variant-1'
                          : 'border-light-green-variant-1'
                      ">
                <img src="../../../../../assets/svg/solar-icon.svg"
                  class=" sm:m-2.5 lg:m-3 sm:h-[33px] sm:w-[33px] lg:h-[31px] lg:w-[31px] xxl:h-[40px] xxl:w-[40px]"
                  alt="preview" />
              </div>
              <div class="col-span-2">
              </div>
              <div class="col-span-1 row-span-1 flex justify-center m-0 h-full line">
                <div class="h-full bg-white rounded-sm overflow-hidden">
                  <div class="h-full w-1">
                    <div class="progress-vertical" [ngClass]="{
                              'animate-top-to-bottom':
                                animationFlow.solarToCenter
                            }"></div>
                  </div>
                </div>
              </div>
              <div class="col-span-2 flex justify-end items-end h-full  mb-2">
                @if (statData?.inverterType === inverterType.ENERTECH_SOLAR ||(
                statData?.inverterType === inverterType.ARCTIC_HYBRID &&
                statData?.stats?.phaseType===3
                ) ){
                <div class="flex h-full justify-end items-end gap-2 -mr-2.5">
                  <div class="rounded-full text-sm h-5 w-5 text-center flex items-center justify-center " [ngClass]="
                    statData?.phase?.phaseR
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">R</div>
                  <div class="rounded-full  text-sm h-5 w-5 text-center flex items-center justify-center " [ngClass]="
                    statData?.phase?.phaseY
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">Y</div>
                  <div class="rounded-full text-sm h-5 w-5 text-center flex items-center justify-center  " [ngClass]="
                    statData?.phase?.phaseB
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">B</div>
                </div>

                }
              </div>
              <div
                class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
             [ngClass]="getGridBorderClass()">
                <img src="../../../../../assets/svg/grid-icon.svg" class="energy-icon-size sm:m-2.5 lg:m-3"
                  alt="preview" />
              </div>
              <div class="w-full line">
                <div class="w-full bg-white rounded-sm overflow-hidden">
                  <div class="h-1 w-full">
                    <div class="progress" [ngClass]="{
                              'animate-left-to-right':
                                animationFlow.gridToCenter,
                              'animate-right-to-left':
                                animationFlow.centerToGrid
                            }"></div>
                  </div>
                </div>
              </div>
              <div
                class="col-span-1 rounded-full flex justify-center items-center sm:w-7 sm:h-7 lg:w-10 lg:h-10 m-auto">
                <img src="../../../../../assets/svg/preview-center.svg" class="sm:w-7 sm:h-7 lg:w-10 lg:h-10"
                  alt="preview" />
              </div>
              <div class="w-full line">
                <div class="w-full bg-white rounded-sm overflow-hidden">
                  <div class="h-1 w-full">
                    <div class="progress" [ngClass]="{
                              'animate-left-to-right':
                                animationFlow.centerToHome
                            }"></div>
                  </div>
                </div>
              </div>
              <div
                class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
                [ngClass]="
                        animationFlow.centerToHome
                          ? 'border-light-green-variant-1'
                          : 'border-light-gray-variant-1'
                      ">
                @if(statData?.inverterType === inverterType.ENERTECH_SOLAR
                ||statData?.inverterType===inverterType.ARCTIC_HYBRID ){
                <img src="../../../../assets/svg/load_state.svg" class="energy-icon-size sm:m-2.5 lg:m-3"
                  alt="preview" />
                }@else {
                <img src="../../../../../assets/svg/home-icon.svg" class="energy-icon-size sm:m-2.5 lg:m-3"
                  alt="preview" />
                }
              </div>
              <div class="col-span-2 flex flex-col justify-start items-start -ml-3.5 mt-2">
                <div class="flex flex-col flex-wrap items-center">
                  @if (statData?.inverterType === inverterType.ENERTECH_SOLAR ||
                  statData?.inverterType===inverterType.ARCTIC_HYBRID
                  ) {
                  @if(statData?.inverterType===inverterType.ENERTECH_SOLAR) {<span
                    class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{
                    "total_grid"
                    | translate }}</span>} @else {
                  <span class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{
                    "grid_power"
                    | translate }}</span>
                  }
                  <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
                    {{ statData?.stats?.totalGrid ?? 0 }}
                    {{statData?.inverterType===inverterType.ARCTIC_HYBRID?'W':'kW'}}
                  </span>
                  } @else{
                  <span class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{
                    "grid_voltage"
                    | translate }}</span>
                  <span
                    class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">{{
                    this.statData?.stats?.input_voltage ?? "0"
                    }}
                    V</span>}
                </div>
              </div>

              <div class="col-span-1 flex justify-center m-0 h-full">
                <div class="h-full bg-white rounded-sm overflow-hidden">
                  <div class="h-full w-1">
                    <div class="progress-vertical" [ngClass]="{
                              'animate-top-to-bottom':
                                animationFlow.centerToBattery,
                              'animate-bottom-to-top':
                                animationFlow.batteryToCenter
                            }"></div>
                  </div>
                </div>
              </div>
              <div class="col-span-2 flex justify-end items-end mt-2">
                <div class="flex flex-col flex-wrap sm:ml-1 md:-mr-2 xl:-mr-2 xxl-mr-1">
                  @if (statData?.inverterType === inverterType.ENERTECH_SOLAR ){
                  <span class="sm:text-base md:text-[1.09125rem] text-center lg:text-base font-normal text-[#AEAEAE]">{{
                    "total_load" | translate }}</span>
                  } @else if(statData?.inverterType===inverterType.ARCTIC_HYBRID){
                  <span class="sm:text-base md:text-[1.09125rem] text-center lg:text-base font-normal text-[#AEAEAE]">{{
                    "load_power" | translate }}</span>
                  } @else{
                  <span class="sm:text-base md:text-[1.09125rem] text-center lg:text-base font-normal text-[#AEAEAE]">{{
                    "home" | translate }}</span>}
                  <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
                    {{ this.statData?.stats?.consumptionValue ?? "0"
                    }}{{statData?.inverterType===inverterType.ARCTIC_HYBRID? ' VA':' kW'}}
                  </span>
                </div>
              </div>
              <div class="col-span-2"></div>

              @if (statData?.inverterType === inverterType.ENERTECH_SOLAR ||
              statData?.inverterType===inverterType.ARCTIC_HYBRID
              ) {
              <div class="rounded-full flex  justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
                [ngClass]="statData?.stats?.batteryState=='Red'?'border-light-red-variant-1':'border-light-green-variant-1'"
                [ngClass]="statData?.stats?.batteryState=='Yellow'?'border-yellow-300':'border-light-green-variant-1'"
                [ngClass]="statData?.stats?.batteryState=='Green'?'border-light-green-variant-1':'border-white'">
                <div
                  class="sm:w-[29px] sm:h-[29px] lg:w-[27px] lg:h-[27px] xxl:h-[42px] xxl:w-[42px] relative sm:m-2.5 lg:m-3">
                  <div
                    class="w-full h-full flex justify-end items-end border-[0.5px] border-solid border-white rounded-b-sm">
                    <div class="w-full bg-[#0051ba] rounded-b-sm" [ngStyle]="{
                              height: calculateBatteryProgress(statData?.stats)
                            }"></div>
                  </div>
                  <div class="battery-top-left"></div>
                  <div class="battery-top-right"></div>
                </div>
              </div>
              }@else
              { <div class="rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
                [ngClass]="
                        animationFlow.centerToBattery ||
                        animationFlow.batteryToCenter
                          ? 'border-light-green-variant-1'
                          : 'border-light-gray-variant-1'
                      ">
                <div
                  class="sm:w-[29px] sm:h-[29px] lg:w-[27px] lg:h-[27px] xxl:h-[42px] xxl:w-[42px] relative sm:m-2.5 lg:m-3">
                  <div
                    class="w-full h-full flex justify-end items-end border-[0.5px] border-solid border-white rounded-b-sm">
                    <div class="w-full bg-[#0051ba] rounded-b-sm" [ngStyle]="{
                              height: calculateBatteryProgress(statData?.stats)
                            }"></div>
                  </div>
                  <div class="battery-top-left"></div>
                  <div class="battery-top-right"></div>
                </div>
              </div> }
              <div class="col-span-2"></div>
            </div>
          </div>
          @if(statData?.inverterType === inverterType.ENERTECH_SOLAR ){
          <div class="flex justify-center items-center w-full flex-col text-white">
            <span
              class="sm:text-base p-0 md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{"battery_charging"|translate}}</span>
            <div class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
              {{statData?.stats?.battery_charge_percentage}}%</div>
          </div>
          } @else if(statData?.inverterType===inverterType.ARCTIC_HYBRID){
          <div class="flex justify-center items-center w-full flex-col text-white">
            <span
              class="sm:text-base p-0 md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{"battery_power"|translate}}</span>
            <div class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
              {{statData?.stats?.batteryPower}} W | {{statData?.stats?.battery_charge_percentage}}%</div>
          </div>
          }
          @else{
          <div class="flex justify-center items-center w-full">
            <div class="justify-center items-center w-full px-2 text-white">
              <div class="flex flex-col flex-wrap items-center">
                <span class="sm:text-base md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{
                  this.statData?.stats?.batteryState?.toString() != "0"
                  ? "Charging"
                  : getState(this.statData?.stats)
                  }}</span>
                @if (
                this.statData?.stats?.batteryState?.toString() != "0"
                ) {
                <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">(
                  {{
                  this.statData?.stats?.time_remaining_for_charging
                  | noxDate
                  }}
                  to charge)</span>
                } @else {
                @if (
                getNumber(statData?.stats?.discharging_current) > 1 ||
                getNumber(statData?.stats?.discharge) > 1
                ) {
                <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">(
                  {{
                  this.statData?.stats?.available_backup
                  ? (this.statData?.stats?.available_backup
                  | noxDate)
                  : (this.statData?.stats
                  ?.time_remaining_for_discharging | noxDate)
                  }}
                  remaining)</span>
                } @else {
                <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">(
                  {{
                  this.statData?.stats?.time_remaining_for_charging
                  | noxDate
                  }}
                  to charge)</span>
                }
                }
              </div>
            </div>
          </div>}
        </div>
        @if(statData?.inverterType!==inverterType.ARCTIC_HYBRID){
        <div class="flex justify-center items-center w-fit">

          <span class="vertical-text text-[#EFEDEF] sm:text-base font-normal md:text-[0.955 rem] lg:text-sm">Load
            Priority:
            {{ statData?.solarSetting }}
          </span>
        </div>}
      </div>
      <!--Detailed Info Button-->
      @if (statData?.inverterType === inverterType.ENERTECH_SOLAR || statData?.inverterType===inverterType.ARCTIC_HYBRID
      ) {<div class="-ml-2.5">
        <div
          class="flex justify-center items-center rounded-full  bg-dark-accent-secondary px-4 py-2 text-white cursor-default gap-x-1 w-fit mt-2"
          (appClickableDirective)="detailedInfoSidesheet.toggle(
          plantType.SOLAR
        )" onClickOutside (onClickOutside)="clickOutside()">
          <span class="text-xs p-0">{{
            "detailed_info" | translate
            }}</span>
          <img src="../../../../../assets/svg/arrow_forward.svg" alt="arrow" />
        </div>

        <div class="text-white cursor-def
      ault mt-1.5">
          <app-detailed-info [plantID]="statData?.stats?.id" [dataLoggerSN]="statData?.deviceId"
            [modelName]="statData?.inverterModel " [phaseType]="statData?.stats?.phaseType"
            [inverterType]="statData?.inverterType"></app-detailed-info>
        </div>
      </div>
      }
    </div>
    }

    <!-- Non solar SolarVerter -->
    @if (this.statData?.plantType === plantType.NON_SOLAR) {
    <div class="flex flex-col items-center ">
      <div class="sm:hidden lg:flex xl:hidden lg:flex-col ">
        <div class="grid grid-cols-5 row-span-5 justify-center items-center px-3 mt-16 grid-auto">
          <div class="col-span-5  flex justify-end items-end h-full  mb-2">

            @if (statData?.inverterType === inverterType.ENERTECH_NON_SOLAR ||
            statData?.inverterType===inverterType.OPTIMUS_3P){
            <div class="flex h-full justify-end items-end gap-2 -mr-2.5">
              <div class="rounded-full text-sm h-5 w-5 text-center flex items-center justify-center     " [ngClass]="
                    statData?.phase?.phaseR
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">R</div>
              <div class="rounded-full  text-sm h-5 w-5 text-center flex items-center justify-center " [ngClass]="
                    statData?.phase?.phaseY
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">Y</div>
              <div class="rounded-full text-sm h-5 w-5 text-center flex items-center justify-center  " [ngClass]="
                    statData?.phase?.phaseB
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">B</div>
            </div>
            }
          </div>
          <div
            class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
            [ngClass]="
                    this.statData?.stats?.grid_state?.toString() == '0'
                      ? 'border-light-red-variant-1'
                      : 'border-light-green-variant-1'
                  ">
            <img src="../../../../../assets/svg/grid-icon.svg" class="energy-icon-size sm:m-2.5 lg:m-3" alt="preview" />
          </div>
          <div class="w-full">
            <div class="w-full bg-white rounded-sm overflow-hidden">
              <div class="h-1 w-full">
                <div class="progress" [ngClass]="{
                          'animate-left-to-right': animationFlow.gridToCenter,
                          'animate-right-to-left': animationFlow.centerToGrid
                        }"></div>
              </div>
            </div>
          </div>
          <div class="col-span-1 rounded-full flex justify-center items-center  sm:w-7 sm:h-7 lg:w-10 lg:h-10 m-auto">
            <img src="../../../../../assets/svg/preview-center.svg" class="sm:w-7 sm:h-7 lg:w-10 lg:h-10"
              alt="preview" />
          </div>
          <div class="w-full">
            <div class="w-full bg-white rounded-sm overflow-hidden">
              <div class="h-1 w-full">
                <div class="progress" [ngClass]="{
                          'animate-left-to-right': animationFlow.centerToHome
                        }"></div>
              </div>
            </div>
          </div>
          <div
            class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
            [ngClass]="
                        animationFlow.centerToHome
                          ? 'border-light-green-variant-1'
                          : 'border-light-gray-variant-1'
                      ">
            @if(statData?.inverterType === inverterType.ENERTECH_NON_SOLAR ||
            statData?.inverterType===inverterType.OPTIMUS_3P ){
            <img src="../../../../assets/svg/load_state.svg" class="energy-icon-size sm:m-2.5 lg:m-3" alt="preview" />
            }@else {
            <img src="../../../../../assets/svg/home-icon.svg" class="energy-icon-size sm:m-2.5 lg:m-3" alt="preview" />
            }
          </div>

          <div class="col-span-2 flex flex-col justify-start items-start  mt-2">
            <div class="flex flex-col">
             @if (statData?.inverterType === inverterType.OPTIMUS_3P) {
              <span
                class="text-[12px] font-normal text-[#AEAEAE] p-0 m-0 mt-1 leading-none">{{
                "grid_voltage" | translate}}</span>
              <div class="phase-wrapper ">
                <div class="phase-slider " [style.transform]="'translateY(-' + (currentIndex * 2) + 'rem)'">

                  @for (phase of phaseList; track phase.label) {
                  <div class="phase-item  flex items-center mr-6 ml-1.5">
                   <span
                      class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB]">
                      {{ phase.label }} - 
                      <span
                        class="text-[15px] pt-1 leading-none font-normal  text-[#EBEAEB]">
                        {{ statData?.phase?.[phase.key] ?? '0V' }}
                      </span>
                    </span>
                  </div>
                  }
                </div>
              </div>
              } 
              @else if (statData?.inverterType === inverterType.ENERTECH_NON_SOLAR
              ) { <span class="text-[12px] font-normal text-[#AEAEAE] p-0 m-0 leading-none ">{{
                "total_grid"
                | translate }}</span>
              <span class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB] ml-1.5"
                [ngClass]="{'ml-3':statData?.stats?.totalGrid==='0'||!statData?.stats?.totalGrid}">
                {{ statData?.stats?.totalGrid ?? 0 }} kW
              </span>
              }@else{
              <span class="text-[12px] font-normal text-[#AEAEAE] p-0 m-0 leading-none">{{ "grid_voltage" |
                translate
                }}</span>
              <span class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB] ml-1.5"
                [ngClass]="{'ml-3': statData?.stats?.input_voltage === '0' || !statData?.stats?.input_voltage}">{{
                this.statData?.stats?.input_voltage
                ??
                "0" }} V</span>}
            </div>
          </div>
          <div class="col-span-1 flex justify-center m-0 h-full">
            <div class="h-full bg-white rounded-sm overflow-hidden">
              <div class="h-full w-1">
                <div class="progress-vertical" [ngClass]="{
                          'animate-top-to-bottom':
                            animationFlow.centerToBattery,
                          'animate-bottom-to-top': animationFlow.batteryToCenter
                        }"></div>
              </div>
            </div>
          </div>

          <div class="col-span-2 flex flex-col justify-end items-end -mr-1 mt-2  ">
            <div class="flex flex-col justify-center items-center "

              [ngClass]="{' mr-0 -mt-20':statData?.stats?.mappingProtocol=='BITWISE',
                '-mr-4':statData?.stats?.consumptionValue!='0.0'|| !statData?.stats?.consumptionValue
              }">
              @if (statData?.inverterType === inverterType.ENERTECH_NON_SOLAR ||
              statData?.inverterType===inverterType.OPTIMUS_3P){
              <span class="text-[12px] font-normal text-[#AEAEAE] p-0 m-0 leading-none">{{
                "total_load" | translate }}</span>
              } @else{
              <span class="text-[12px] p-0 mt-1 leading-none font-normal  text-[#AEAEAE]">{{
                "home" | translate }}</span>}
              @if (statData?.stats?.mappingProtocol != "BITWISE") {
              <span class="text-[15px] pt-1 leading-none font-normal text-nowrap text-[#EBEAEB] mr-2 mt-2"
                [ngClass]="{'ml-2': statData?.stats?.consumptionValue  === '0.0' || !statData?.stats?.consumptionValue||statData?.stats?.consumptionValue  === '0'}">{{
                this.statData?.stats?.consumptionValue ?? "0"
                }}
                kW</span>
              }
            </div>
          </div>

          <div class="col-span-2"></div>
          @if (statData?.inverterType === inverterType.ENERTECH_NON_SOLAR ||
          statData?.inverterType===inverterType.OPTIMUS_3P
          ) {
          <div
            class="col-span-1 rounded-full flex  justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
            [ngClass]="statData?.stats?.batteryState=='Red'?'border-light-red-variant-1':'border-light-green-variant-1'"
            [ngClass]="statData?.stats?.batteryState=='Yellow'?'border-yellow-300':'border-light-green-variant-1'"
            [ngClass]="statData?.stats?.batteryState=='Green'?'border-light-green-variant-1':'border-white'">
            <div class="relative w-fit m-2">
              <div class="energy-icon-size">
                <div
                  class="w-full h-full absolute top-0 left-0 flex justify-end items-end border-[0.5px] border-solid border-white rounded-b-sm">
                  <div class="w-full bg-[#0051ba] rounded-b-sm" [ngStyle]="{
                              height: calculateBatteryProgress(statData?.stats)
                            }"></div>
                </div>
                <div class="battery-top-left"></div>
                <div class="battery-top-right"></div>
              </div>
            </div>
          </div>
          }@else
          {
          <div
            class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
            [ngClass]="
                    animationFlow.centerToBattery ||
                    animationFlow.batteryToCenter
                      ? 'border-light-green-variant-1'
                      : 'border-light-gray-variant-1'
                  ">
            <div class="relative w-fit m-2">
              <div class="energy-icon-size">
                <div
                  class="w-full h-full absolute top-0 left-0 flex justify-end items-end border-[0.5px] border-solid border-white rounded-b-sm">
                  <div class="w-full bg-[#0051ba] rounded-b-sm" [ngStyle]="{
                            height: calculateBatteryProgress(statData?.stats)
                          }"></div>
                </div>
                <div class="battery-top-left"></div>
                <div class="battery-top-right"></div>
              </div>
            </div>
          </div> }
        </div>
        @if (statData?.inverterType===inverterType.OPTIMUS_3P) {
        <div class="flex justify-center items-center w-full flex-col text-white">
          <span class="text-[12px] font-normal text-[#AEAEAE] p-0 m-0 leading-none">{{"battery"|translate}}</span>
          <div class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB] mt-2">
            {{statData?.batteryVoltage}} V</div>
        </div>
        }@else if(statData?.inverterType === inverterType.ENERTECH_NON_SOLAR ){
        <div class="flex justify-center items-center w-full flex-col text-white">
          <span
            class="text-[12px] font-normal text-[#AEAEAE] p-0 m-0 leading-none">{{"battery_charging"|translate}}</span>
          <div class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB] mt-2">
            {{statData?.stats?.battery_charge_percentage}}%</div>
        </div>
        }
        @else{
        <div class="flex flex-col justify-center items-center">
          <div class="justify-center items-center px-2">
            <span class="text-[12px] font-normal text-[#AEAEAE] p-0 m-0 leading-none">{{
              this.statData?.stats?.batteryState?.toString() !== "0"
              ? "Charging"
              : getState(this.statData?.stats)
              }}</span>
          </div>
          @if (this.statData?.stats?.batteryState?.toString() !== "0") {
          <span class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB]">(
            {{
            this.statData?.stats?.time_remaining_for_charging
            | noxDate
            }}
            to charge)</span>
          } @else {
          @if (
          getNumber(statData?.stats?.discharging_current) > 1 ||
          getNumber(statData?.stats?.discharge) > 1
          ) {
          <span class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB]">(
            {{
            this.statData?.stats?.time_remaining_for_discharging
            | noxDate
            }}
            remaining)</span>
          } @else {
          <span class="text-[15px] pt-1 leading-none font-normal text-[#EBEAEB]">(
            {{
            this.statData?.stats?.time_remaining_for_charging
            | noxDate
            }}
            to charge)</span>
          }
          }
        </div>
        }
      </div>
      <div class="sm:flex xl:flex lg:hidden flex-col ">
        <div class="grid grid-cols-5 row-span-5 justify-center  items-center px-3 mt-12 grid-auto"
          [ngClass]="{'mt-7':statData?.inverterType===inverterType.ENERTECH_NON_SOLAR || statData?.inverterType === inverterType.OPTIMUS_3P}">
          @if (statData?.inverterType === inverterType.ENERTECH_NON_SOLAR || statData?.inverterType ===
          inverterType.OPTIMUS_3P){
          <div class="col-span-5  flex justify-end items-end h-full  mb-2">
            <div class="flex h-full justify-end items-end gap-2 -mr-2.5">
              <div class="rounded-full text-sm h-5 w-5 text-center flex items-center justify-center     " [ngClass]="
                    statData?.phase?.phaseR
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">R</div>
              <div class="rounded-full  text-sm h-5 w-5 text-center flex items-center justify-center  " [ngClass]="
                    statData?.phase?.phaseY
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">Y</div>
              <div class="rounded-full text-sm h-5 w-5 text-center flex items-center justify-center  " [ngClass]="
                    statData?.phase?.phaseB
                      ? 'bg-green-500'
                      : 'bg-white'
                  ">B</div>
            </div>
          </div>
          }
          <div
            class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
            [ngClass]="
                    this.statData?.stats?.grid_state?.toString() == '0'
                      ? 'border-light-red-variant-1'
                      : 'border-light-green-variant-1'
                  ">
            <img src="../../../../../assets/svg/grid-icon.svg" class="energy-icon-size sm:m-2.5 lg:m-3" alt="preview" />
          </div>
          <div class="w-full">
            <div class="w-full bg-white rounded-sm overflow-hidden">
              <div class="h-1 w-full">
                <div class="progress" [ngClass]="{
                          'animate-left-to-right': animationFlow.gridToCenter,                  
                          'animate-right-to-left': animationFlow.centerToGrid
                        }"></div>
              </div>
            </div>
          </div>
          <div class="col-span-1 rounded-full flex justify-center items-center sm:w-7 sm:h-7 lg:w-10 lg:h-10 m-auto">
            <img src="../../../../../assets/svg/preview-center.svg" class="sm:w-7 sm:h-7 xl:w-10 xl:h-10 m-auto"
              alt="preview" />
          </div>
          <div class="w-full">
            <div class="w-full bg-white rounded-sm overflow-hidden">
              <div class="h-1 w-full">
                <div class="progress" [ngClass]="{
                          'animate-left-to-right': animationFlow.centerToHome
                        }"></div>
              </div>
            </div>
          </div>
          <div
            class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
            [ngClass]="
                        animationFlow.centerToHome
                          ? 'border-light-green-variant-1'
                          : 'border-light-gray-variant-1'
                      ">
            @if(statData?.inverterType === inverterType.ENERTECH_NON_SOLAR ||
            statData?.inverterType===inverterType.OPTIMUS_3P ){
            <img src="../../../../assets/svg/load_state.svg" class="energy-icon-size sm:m-2.5 lg:m-3" alt="preview" />
            }@else {
            <img src="../../../../../assets/svg/home-icon.svg" class="energy-icon-size sm:m-2.5 lg:m-3" alt="preview" />
            }
          </div>
          <div class="col-span-2 flex flex-col justify-start items-start mt-2 ">
            <div class="flex flex-col">

              @if (statData?.inverterType === inverterType.OPTIMUS_3P) {
              <span
                class="sm:text-base md:text-[1.09125rem] m-0 pr-2.5 p-0 text-center lg:text-base font-normal text-[#AEAEAE] -ml-4 mb-[0.15rem]">{{
                "grid_voltage" | translate}}</span>
              <div class="phase-wrapper ">
                <div class="phase-slider " [style.transform]="'translateY(-' + (currentIndex * 2) + 'rem)'">

                  @for (phase of phaseList; track phase.label) {
                  <div class="phase-item  flex items-center mr-6 ">
                   <span
                      class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl  mt-2 font-normal text-[#EBEAEB]">
                      {{ phase.label }} - 
                      <span
                        class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal  text-[#EBEAEB]">
                        {{ statData?.phase?.[phase.key] ?? '0V' }}
                      </span>
                    </span>
                  </div>
                  }
                </div>
              </div>
              }
              @else if (statData?.inverterType === inverterType.ENERTECH_NON_SOLAR
              ) { <span
                class="sm:text-base md:text-[1.09125rem] m-0 pr-2.5 p-0 text-center lg:text-base font-normal text-[#AEAEAE] ">{{
                "total_grid" | translate }}</span>

              <span class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]"
                [ngClass]="{'ml-3':statData?.stats?.totalGrid==='0'||!statData?.stats?.totalGrid}">
                {{ statData?.stats?.totalGrid ?? 0 }} kW
              </span>
              }@else{
              <span
                class="sm:text-base md:text-[1.09125rem] m-0 pr-2.5 p-0 text-center lg:text-base font-normal text-[#AEAEAE] -ml-4">{{
                "grid_voltage" | translate}}</span>
              <span
                class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB] -ml-1.5"
                [ngClass]="{'ml-3': statData?.stats?.input_voltage === '0' || !statData?.stats?.input_voltage}">{{
                this.statData?.stats?.input_voltage
                ??
                "0" }} V</span>}
            </div>
          </div>
          <div class="col-span-1 flex justify-center m-0   h-full">
            <div class="h-full bg-white rounded-sm overflow-hidden">
              <div class="h-full w-1">
                <div class="progress-vertical" [ngClass]="{
                          'animate-top-to-bottom':
                            animationFlow.centerToBattery,
                          'animate-bottom-to-top': animationFlow.batteryToCenter
                        }"></div>
              </div>
            </div>
          </div>
          <div class="col-span-2  flex flex-col h-fit items-end mt-2 "
            [ngClass]="{'items-center ':statData?.stats?.mappingProtocol=='BITWISE'}">
            <div class="flex flex-col  h-fit w-fit  -mr-4"
              [ngClass]="{'  ml-14 -mt-7':statData?.stats?.mappingProtocol=='BITWISE'}">
              @if (statData?.inverterType === inverterType.ENERTECH_NON_SOLAR || statData?.inverterType ===
              inverterType.OPTIMUS_3P){
              <span
                class="sm:text-base md:text-[1.09125rem] m-0 pr-2.5 p-0 text-center lg:text-base font-normal text-[#AEAEAE]">{{
                "total_load" | translate }}</span>
              } @else{

              <span
                class="sm:text-base md:text-[1.09125rem] m-0 pr-2.5 p-0 text-center lg:text-base font-normal text-[#AEAEAE]">
                {{ 'home' | translate }}
              </span>
              }
              @if (statData?.stats?.mappingProtocol != "BITWISE") {
              <span
                class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]  -ml:1"
                [ngClass]="{'ml-2': statData?.stats?.consumptionValue  === '0.0' || !statData?.stats?.consumptionValue||statData?.stats?.consumptionValue  === '0'}">{{
                this.statData?.stats?.consumptionValue ?? "0"
                }}
                kW</span>
              }
            </div>
          </div>
          <div class="col-span-2"></div>
          @if (statData?.inverterType === inverterType.ENERTECH_NON_SOLAR ||
          statData?.inverterType===inverterType.OPTIMUS_3P
          ) {
          <div class="rounded-full flex  justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
            [ngClass]="statData?.stats?.batteryState=='Red'?'border-light-red-variant-1':'border-light-green-variant-1'"
            [ngClass]="statData?.stats?.batteryState=='Yellow'?'border-yellow-300':'border-light-green-variant-1'"
            [ngClass]="statData?.stats?.batteryState=='Green'?'border-light-green-variant-1':'border-white'">
            <div
              class="sm:w-[29px] sm:h-[29px] lg:w-[27px] lg:h-[27px] xxl:h-[42px] xxl:w-[42px] relative sm:m-2.5 lg:m-3">
              <div
                class="w-full h-full flex justify-end items-end border-[0.5px] border-solid border-white rounded-b-sm">
                <div class="w-full bg-[#0051ba] rounded-b-sm" [ngStyle]="{
                              height: calculateBatteryProgress(statData?.stats)
                            }"></div>
              </div>
              <div class="battery-top-left"></div>
              <div class="battery-top-right"></div>
            </div>
          </div>
          }@else
          { <div class="rounded-full flex justify-center items-center h-fit w-fit m-auto border-[2px] border-solid"
            [ngClass]="
                        animationFlow.centerToBattery ||
                        animationFlow.batteryToCenter
                          ? 'border-light-green-variant-1'
                          : 'border-light-gray-variant-1'
                      ">
            <div
              class="sm:w-[29px] sm:h-[29px] lg:w-[27px] lg:h-[27px] xxl:h-[42px] xxl:w-[42px] relative sm:m-2.5 lg:m-3">
              <div
                class="w-full h-full flex justify-end items-end border-[0.5px] border-solid border-white rounded-b-sm">
                <div class="w-full bg-[#0051ba] rounded-b-sm" [ngStyle]="{
                              height: calculateBatteryProgress(statData?.stats)
                            }"></div>
              </div>
              <div class="battery-top-left"></div>
              <div class="battery-top-right"></div>
            </div>
          </div> }

          <div class="col-span-2"></div>
        </div>
        @if(statData?.inverterType===inverterType.OPTIMUS_3P ){
        <div class="flex justify-center items-center w-full flex-col text-white">
          <span
            class="sm:text-base p-0 md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{"battery"|translate}}</span>
          <div class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
            {{statData?.batteryVoltage}} V</div>
        </div>
        }
        @else if(statData?.inverterType === inverterType.ENERTECH_NON_SOLAR ){
        <div class="flex justify-center items-center w-full flex-col text-white">
          <span
            class="sm:text-base p-0 md:text-[1.09125rem] lg:text-base font-normal text-[#AEAEAE]">{{"battery_charging"|translate}}</span>
          <div class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-xl mt-2 font-normal text-[#EBEAEB]">
            {{statData?.stats?.battery_charge_percentage}}%</div>
        </div>
        }
        @else{
        <div class="flex flex-col justify-center items-center">
          <div class="justify-center items-center px-2 text-white">
            <span class="sm:text-base md:text-[1.09125rem] m-0 p-0 lg:text-base font-normal text-[#AEAEAE]">{{
              this.statData?.stats?.batteryState?.toString() !== "0"
              ? "Charging"
              : getState(this.statData?.stats)
              }}</span>
          </div>
          @if (this.statData?.stats?.batteryState?.toString() !== "0") {
          <span class="font-roboto sm:text-xl md:text-[1.17625rem] p-0 lg:text-xl mt-2 font-normal text-[#EBEAEB]">(
            {{
            this.statData?.stats?.time_remaining_for_charging
            | noxDate
            }}
            to charge)</span>
          } @else {
          @if (
          getNumber(statData?.stats?.discharging_current) > 1 ||
          getNumber(statData?.stats?.discharge) > 1
          ) {
          <span class="font-roboto sm:text-xl md:text-[1.17625rem] p-0 lg:text-xl mt-2 font-normal text-[#EBEAEB]">(
            {{
            this.statData?.stats?.time_remaining_for_discharging
            | noxDate
            }}
            remaining)</span>
          } @else {
          <span class="font-roboto sm:text-xl md:text-[1.17625rem] p-0 lg:text-xl mt-2 font-normal text-[#EBEAEB]">(
            {{
            this.statData?.stats?.time_remaining_for_charging
            | noxDate
            }}
            to charge)</span>
          }
          }
        </div>
        }

      </div>
      <div class="flex justify-center w-full">
        @if (
        statData?.inverterType===inverterType.ENERTECH_NON_SOLAR || statData?.inverterType===inverterType.OPTIMUS_3P) {
        <div class="ml-1">
          <div
            class="flex justify-center items-center rounded-full  bg-dark-accent-secondary px-4 py-2 text-white cursor-default gap-x-1 w-fit mt-2"
            (appClickableDirective)="detailedInfoSidesheet.toggle(
          plantType.NON_SOLAR
        )" onClickOutside (onClickOutside)="clickOutside()">
            <span class="text-xs p-0">{{
              "detailed_info" | translate
              }}</span>
            <img src="../../../../../assets/svg/arrow_forward.svg" alt="arrow" />
          </div>

          <div class="text-white cursor-def
      ault mt-1.5">
            <app-detailed-info [plantID]="statData?.stats?.id" [dataLoggerSN]="statData?.deviceId"
              [modelName]="statData?.inverterModel" [inverterType]="statData?.inverterType"></app-detailed-info>
          </div>
        </div>
        }
      </div>
    </div>
    }
    @if(this.statData?.inverterType==inverterType.THINKPOWERHESM){
    <div class="w-full h-full flex flex-col items-center ">
      <div class="flex flex-col sm:px-3 sm:w-[75%] md:w-[100%] lg:w-full justify-center items-center ">
        <div class="flex flex-col justify-center items-center">
          <div class="flex flex-col flex-wrap items-center">
            <span class="sm:text-base md:text-[1.09125rem] lg:text-[12px] xl:text-base font-normal text-[#AEAEAE] ">{{
              "solar_power" | translate
              }}</span>
            <span
              class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-[15px] xl:text-xl mt-2 font-normal text-[#EBEAEB]">{{
              statData?.stats?.solar_power ?? 0
              }} kW</span>
          </div>

          <div
            class="col-span-1 mt-2 rounded-full flex justify-center items-center h-fit w-fit border-[2px] border-solid"
            [ngClass]="
               this.solarPower<=0.05
                      ? 'border-light-red-variant-1'
                      : 'border-light-green-variant-1'
                  ">
            <img src="../../../../../assets/svg/solar-icon.svg"
              class="sm:w-[32px] sm:h-[32px] lg:h-[30px] lg:w-[30px] xxl:h-[40px] xxl:w-[40px] sm:m-2.5 lg:m-2 xl:m-3"
              alt="preview" />
          </div>
        </div>

        <div class="sm:h-16 lg:h-12 xl:h-16 flex justify-center ">
          <div class="h-full bg-white rounded-sm overflow-hidden">
            <div class="h-full w-1">
              <div class="progress-vertical" [ngClass]="{
                              'animate-top-to-bottom':
                                animationFlow.solarToCenter
                            }"></div>
            </div>
          </div>
        </div>
        <div class="flex w-full items-center">
          <div class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit border-[2px] border-solid"
            [ngClass]="
                    this.statData?.stats?.grid_state?.toString() == '1'
                      ? 'border-light-red-variant-1'
                      : 'border-light-green-variant-1'
                  ">
            <img src="../../../../../assets/svg/grid-icon.svg"
              class="sm:w-[32px] sm:h-[32px] lg:h-[30px] lg:w-[30px] xxl:h-[40px] xxl:w-[40px] sm:m-2.5 lg:m-2 xl:m-3"
              alt="preview" />
          </div>

          <div class="flex-grow lines">
            <div class="w-full bg-white rounded-sm overflow-hidden">
              <div class="h-1 w-full flex-grow">
                <div class="progress" [ngClass]="{
                          'animate-left-to-right': animationFlow.gridToCenter,
                          'animate-right-to-left':animationFlow.centerToGrid
                        }"></div>
              </div>
            </div>
          </div>
          <div class="rounded-full flex justify-center items-center sm:w-7 sm:h-7 lg:w-10 lg:h-10 m-auto">
            <div class="w-fit h-fit">
              <img src="../../../../../assets/svg/preview-center.svg" class="sm:w-7 sm:h-7 lg:w-10 lg:h-10"
                alt="preview" />
            </div>
          </div>

          <div class="flex-grow lines">
            <div class="w-full bg-white rounded-sm overflow-hidden">
              <div class="h-1 w-full">


                <div class="progress" [ngClass]="{
       'animate-left-to-right': animationFlow.centerToHome,
  
     }">
                </div>


              </div>
            </div>
          </div>
          <div class="col-span-1 rounded-full flex justify-center items-center h-fit w-fit border-[2px] border-solid"
            [ngClass]="
                     animationFlow.centerToHome
                          ? 'border-light-green-variant-1'
                          : 'border-light-gray-variant-1'
                  ">
            <img src="../../../../../assets/svg/home-icon.svg"
              class="sm:w-[32px] sm:h-[32px] lg:h-[30px] lg:w-[30px] xxl:h-[40px] xxl:w-[40px] sm:m-2.5 lg:m-2 xl:m-3"
              alt="preview" />
          </div>
        </div>
        <!--Heading-part-->
        <div class="flex justify-between w-full mt-3 lg:px-2 xl:px-0">
          <div class="flex flex-col h-fit w-fit text-center -ml-4">
            <span class="sm:text-base md:text-[1.09125rem] lg:text-[12px] xl:text-base font-normal text-[#AEAEAE]">{{
              "grid_power" |
              translate }}</span>
            <span
              class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-[15px] xl:text-xl mt-2 font-normal text-[#EBEAEB]">
              {{ statData?.stats?.totalGrid ?? 0
              }} kW</span>
          </div>
          <div class="flex flex-col h-fit w-fit text-center -mr-4">
            <span class="sm:text-base md:text-[1.09125rem] lg:text-[12px] xl:text-base font-normal text-[#AEAEAE]">{{
              "load_power" |
              translate }}</span>
            <span
              class="font-roboto sm:text-xl md:text-[1.17625rem] lg:text-[15px] xl:text-xl mt-2 font-normal text-[#EBEAEB]">

              {{ statData?.stats?.consumptionValue ?? 0
              }} kW
            </span>
          </div>

        </div>
        <div class="mt-3">
          @if (statData?.stats?.grid_state == "1") {
          <span class="text-white label-xs text-center m-auto mb-5">
            Solar generation paused due to power cut, will resume when
            power's back.
          </span>
          }
        </div>

      </div>
      @if (stringInfo) {
      <div
        class="flex justify-center items-center rounded-xl bg-dark-accent-secondary px-4 py-3 text-white cursor-default gap-x-1"
        (appClickableDirective)="sideSheet.toggle()">
        <span class="text-xs p-0">{{
          "string_info" | translate
          }}</span>
        <img src="../../../../../assets/svg/arrow_forward.svg" alt="arrow" />
      </div>

      <div class="text-white cursor-default">
        <app-string-info [statsData]="statData" [plantName]=" plantName"></app-string-info>
      </div>
      }

    </div>

    }
    } @else {
    <!-- UI for Alerts  -->
    <div class="flex flex-col justify-around items-center h-full">
      <div class="flex flex-col items-center">
        <div class="text-center sm:mt-1">
          <span
            class="font-semibold sm:text-[1.88625rem] text-[#FFFFFF] md:text-xl lg:text-[1.408125rem] h-[4.375rem] leading-[100%]">Inverter
            Detected
          </span>
        </div>
        @if (noxAlert === alertType.SHORT_CIRCUIT) {
        <div class="flex flex-col w-fit items-center">
          <div class="text-center sm:mt-1">
            <span
              class="font-semibold sm:text-[1.88625rem] text-[#FFFFFF] md:text-xl lg:text-[1.408125rem] h-[4.375rem] leading-[100%]">Short
              circuit</span>
          </div>
          <div class="mt-8 w-fit">
            <img src="../../../../../assets/svg/short-circuit-alert.svg"
              class="sm:h-[4.909621238708496rem] sm:w-[6.4937rem] md:h-[3.6651rem] md:w-[4.8476rem] lg:h-[3.6651rem]"
              alt="preview" />
          </div>
        </div>
        } @else if (noxAlert === alertType.INVERTER_OVERHEATED) {
        <div class="flex flex-col w-fit items-center">
          <div class="text-center sm:mt-1">
            <span
              class="font-semibold sm:text-[1.88625rem] text-[#FFFFFF] md:text-xl lg:text-[1.408125rem] h-[4.375rem] leading-[100%]">High
              Temperature</span>
          </div>
          <div class="mt-8 w-fit">
            <img src="../../../../assets/svg/high-temperature.svg"
              class="sm:h-[9.461614608764648rem] md:h-[6.488142013549805rem] lg:h-[6.488142013549805rem]"
              alt="preview" />
          </div>
        </div>
        } @else if (
        noxAlert === alertType.SHORT_CIRCUIT_AND_INVERTER_OVERHEATED
        ) {
        <div class="w-fit flex-col flex items-center">
          <div class="text-center w-fit mt-1.5">
            <span
              class="font-semibold sm:text-[1.88625rem] text-[#FFFFFF] md:text-xl lg:text-[1.408125rem] h-[4.375rem] leading-[100%]">Short
              Circuit and High Temperature</span>
          </div>
          <div class="flex w-fit mt-8 items-center">
            <div>
              <img src="../../../../../assets/svg/short-circuit-alert.svg"
                class="sm:h-[4.909621238708496rem] sm:w-[8.414535522460938rem] md:h-[4.308764rem] md:w-[5.6988rem] lg:h-[3.211rem] lg:w-[4.2469rem]"
                alt="preview" />
            </div>
            <div>
              <img src="../../../../assets/svg/high-temperature.svg" alt="preview" />
            </div>
          </div>
        </div>
        }
      </div>

      <div class="mt-3 text-center">
        <span class="font-normal text-white sm:text-2xl opacity-[80%] md:text-base text-center lg:text-[1.12rem]">Fault
          has been detected in your inverter. We recommend you to
          restart the inverter.</span>
      </div>
      <div class="flex flex-col mb-7 mt-6 text-center">
        <div>
          <span class="text-white text-center leading-tight font-normal sm:text-[1.17875rem] md:text-[0.88rem]">
            In case of Any Emergency
          </span>
        </div>
        <div>
          <span class="text-white text-center leading-tight font-normal sm:text-[1.17875rem] md:text-[0.88rem]">Contact
            our
            <span
              class="cursor-default underline text-white text-center leading-tight font-normal sm:text-[1.17875rem] md:text-[0.88rem]">
              Customer Support</span></span>
        </div>
      </div>
    </div>
    }
    } @else {
    <div class="flex flex-col sm:mt-14 sm:mb-14  justify-center items-center w-full h-full">
      <div class="h-fit w-fit flex flex-col items-center">
        <div class=" bg-[#455160] rounded-full h-fit w-fit flex justify-center items-center">
          <img src="../../../../assets/svg/device-offline.svg" class=" sm:h-20 sm:w-20 m-2.5" alt="preview" />
        </div>

        <div class="mt-5 w-fit">
          <span class="font-medium sm:text-xl text-white lg:text-2xl h-[2.0625rem] leading-[100%]">Your device is
            offline</span>
        </div>

        <div
          class="flex justify-center items-center rounded-full bg-dark-accent-secondary px-4 py-[0.4rem] mt-3.5 text-white cursor-default gap-x-1"
          (appClickableDirective)="openDialog()">

          <div>
            <span class="sm:text-sm text-nowrap">{{
              "click_here" | translate
              }}</span>
          </div>
          <div class="mt-0.5">
            <app-chevron-right-icon class="ml-1 w-2 h-2" />
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>